function isAnyPartOfElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
  const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

  // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
  const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
  const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

  return (vertInView && horInView);
}

function resizeAndLoad() {
  if (window.innerWidth < 768) {
    let first = $('.product-single__description-full .collapsible').first();
    first.addClass('open');
    first.find('.content').show();
  }
}

$(window).scroll(function () {
  if (document.querySelector('body').classList.contains('template-product')) {
    if (isAnyPartOfElementInViewport(document.querySelector('.site-footer'))) {
      if (!document.querySelector('.floating-cta').classList.contains('hidden')) {
        document.querySelector('.floating-cta').classList.add('hidden');
      }
    } else {
      if (document.querySelector('.floating-cta').classList.contains('hidden')) {
        document.querySelector('.floating-cta').classList.remove('hidden');
      }
    }
  }
})

$(window).resize(function () {
  resizeAndLoad();
})


resizeAndLoad();

$('#trigger-add-to-cart').click(function () {
  $('.product-single__form button[type="submit"]').click()
});

var OptionSizeGuide = document.querySelector('#OptionSizeGuide')
if (OptionSizeGuide) {
  OptionSizeGuide.addEventListener('click', function () {
    document.documentElement.classList.add('modal-open')
    document.querySelector('body').classList.add('modal-open')

    document.querySelector('#OptionSizeGuideModal').classList.add('modal--is-active')

    document.querySelector('#OptionSizeGuideModal.modal--is-active').addEventListener('click', function () {
      if (document.querySelector('#OptionSizeGuideModal.modal--is-active') !== event.target) return;

      document.documentElement.classList.remove('modal-open');
      document.querySelector('body').classList.remove('modal-open');

      document.querySelector('#OptionSizeGuideModal').classList.remove('modal--is-active');
    });
  });

  document.querySelector('#OptionSizeGuideModal .js-modal-close').addEventListener('click', function () {
    document.documentElement.classList.remove('modal-open');
    document.querySelector('body').classList.remove('modal-open');

    document.querySelector('#OptionSizeGuideModal').classList.remove('modal--is-active');
  });
}

$('.collapsible').click(function () {
  if (window.innerWidth < 768) {
    const others = $('.collapsible.open').not(this);
    others.removeClass('open');
    others.find('.content').slideUp();
    $(this).toggleClass('open');
    $(this).find('.content').slideToggle();
  }
});

/* SIZE GUIDE */
$('.size-guide__exit').click(function () {
  sizeGuideHide();
});

$('.size-guide-section .overlay').click(function () {
  sizeGuideHide();
});

/* RE-INTITIATE */
$('a[href="#size-guide"]').click(function () {
  sizeGuideShow();
});

$('button.choose-variant-button').on('click', function (e) {
  $('.variant-wrapper--dropdown').each(function () {
    const elem = $(this)
    if (elem.find('select option.no-choose')) {
      var elOffset = elem.offset().top;
      var elHeight = elem.height();
      var windowHeight = $(window).height();
      var offset;

      if (elHeight < windowHeight) {
        offset = elOffset - ((windowHeight / 2) - (elHeight / 2));
      } else {
        offset = elOffset;
      }

      var speed = 500;
      //$('html, body').animate({scrollTop: offset}, speed);

      document.querySelector('.product-single__title').scrollIntoView({behavior: 'smooth'});

      setTimeout(function () {
        elem.addClass('shakeAnimation');
        setTimeout(function () {
          elem.removeClass('shakeAnimation');
        }, 2000)
      }, speed);
    }
  });
});

function sizeGuideShow() {
  $('.size-guide-section').removeClass('visually-hidden');
  $('body').addClass('size-guide-active');
}

function sizeGuideHide() {
  $('.size-guide-section').addClass('visually-hidden');
  $('body').removeClass('size-guide-active');
}

document.addEventListener('variant:change', function (evt) {
  var elem = document.querySelector('.no-choose');
  if (elem) {
    elem.parentNode.removeChild(elem);
  }

  var elemVariant = document.querySelector('.choose-variant-button');
  if (elemVariant) {
    elemVariant.parentNode.removeChild(elemVariant);
  }

  var variant = evt.detail.variant;
  var cartBtn = document.querySelector('.choose-variant-button-container .add-to-cart');
  var cartBtnText = cartBtn.querySelector('span');
  if (!cartBtn || !cartBtnText) {
    return;
  }

  if (variant) {
    if (variant.available) {
      // Available, enable the submit button and change text
      cartBtn.classList.remove('disabled');
      cartBtn.disabled = false;
      var defaultText = cartBtnText.dataset.defaultText;
      cartBtnText.textContent = defaultText;
    } else {
      // Sold out, disable the submit button and change text
      cartBtn.classList.add('disabled');
      cartBtn.disabled = true;
      cartBtnText.textContent = theme.strings.soldOut;
    }
  } else {
    // The variant doesn't exist, disable submit button
    cartBtn.classList.add('disabled');
    cartBtn.disabled = true;
    cartBtnText.textContent = theme.strings.unavailable;
  }
});

var readMore = document.querySelector('.read-more-desc');
if(readMore){
  readMore.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('.product-single-content').scrollIntoView({behavior: 'smooth'});
  });
}